import { WizardStepProps } from "./types";

export default function WizardStep(_: Readonly<WizardStepProps>) {
  return null;
}
